export default __webpack_public_path__ + "static/media/dolphin.0e352ee7.jpg";